import { render, staticRenderFns } from "./loadingtext.vue?vue&type=template&id=c5c59ba2&scoped=true"
import script from "./loadingtext.vue?vue&type=script&lang=js"
export * from "./loadingtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c59ba2",
  null
  
)

export default component.exports